import userAppThumb from '../assets/projectsPictures/userAppThumb.png';
import adminApp from '../assets/projectsPictures/adminApp.png';
import facebookFeed from '../assets/projectsPictures/facebookFeed.png';
import healthDataApp from '../assets/projectsPictures/healthDataApp.png';
import kokoLive from '../assets/projectsPictures/kokoLive.png';
import taskManagementApp from '../assets/projectsPictures/taskManagementApp.png';
import orderStatus from '../assets/projectsPictures/orderStatus.png';
import registrationForm from '../assets/projectsPictures/registrationForm.png';
import multiImageView from '../assets/projectsPictures/multiImageView.png';
import stepperFormUI from '../assets/projectsPictures/stepperFormUI.png';
import expenseManagementRESTAPI from '../assets/projectsPictures/expenseManagementRESTAPI.png';
import djangoRESTFramework from '../assets/projectsPictures/djangoRESTFramework.png';
import thiApp from '../assets/projectsPictures/thiApp.png';
import studyBuddy from '../assets/projectsPictures/StudyBuddy.png';
import time_teacker from '../assets/projectsPictures/time_teacker.jpg';
import designersDesign from '../assets/projectsPictures/designersDesign.png';
import workspace369 from '../assets/projectsPictures/workspace369.png';

export const getProjectSlug = (name) =>
  name
    .toLowerCase()
    .replace(/['']/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const projectsData = [
  {
    name: "Workspace369",
    heading: "This is an all-in-one solution for small businesses, from project initiation to customer success.",
    details: "Workspace369 is a client-work operating system built with Flutter. It brings quotes, invoices, projects, requests, CRM, inbox, files, schedules, payments, AI workflows, and reporting into one workspace so small businesses can run the full journey from first request to final payment without stitching together separate tools.",
    thumb: workspace369,
    tech: "Flutter/Dart",
    links: {
      live: "https://workspace369.com/",
      repo: ""
    }
  },
  {
    //1
    name: "Ominiks-kids",
    heading: "Find the teacher for your student and monitor every single move",
    details: "Built a study collaboration app for Student, Guardian, and Educator, with a secure guardian monitoring system. A full-fledged Chat messaging system integrated into the app with push notifications. Integrated AI-assisted matching algorithm to get the best teachers.",
    thumb: studyBuddy,
    tech: "Flutter/Dart/Firebase",
    links: {
      live: "",
      repo: ""
    }
  },
  {
    //time tracker
    name: "E-Pontaj",
    heading: "Save the time, track smartly",
    details: "E-Pontaj is an employee time-tracking and workforce management application built with Flutter. The app lets field and site-based workers log hours with geolocation, while admins manage users, clients, and job locations. It includes leave requests with approval workflows and reporting tools for accounting and management. The project integrates Auth0 authentication, a REST backend API, and multi-language support (EN/RO/DE/RU) for cross-platform use on mobile and web.",
    thumb: time_teacker,
    tech: "Flutter/Dart/Rest-APIs",
    links: {
      live: "https://vp-solutions.ro/pontaj-prezentare-test/",
      repo: ""
    }
  },
  {
    //designers design
    name: "Designers-Design",
    heading: "Concept submission & review platform for Android and iOS",
    details: "Developed a mobile app for designers to post visual concepts and for reviewers/admins to evaluate submissions through likes, reactions, and feed-based review. Implemented user auth (email, Google, Apple), splash-based session routing, and Firebase-backed post storage with image upload. Built a social-style feed with posts, “My Day” stories, profiles, search/navigation, and share/save interactions. Used Flutter, Firebase (Auth, Firestore, Storage), Provider, and Go Router for state management and navigation.",
    thumb: designersDesign,
    tech: "Flutter/Dart/Firebase",
    links: {
      live: "",
      repo: ""
    }
  },




  {
    //1
    name: "Online Store App",
    heading: "Launch and manage your online store with easily.",
    details: "A ready-to-use solution for small business owners to start selling products online. This app includes essential features like user authentication, product browsing with categories and recommendations, cart management, favorites, order placement, and customizable themes. Perfect for entrepreneurs looking to quickly establish a presence on Android and iOS platforms.",
    thumb: userAppThumb,
    tech: "Flutter/Dart/Firebase",
    links: {
      live: "https://youtu.be/nPo_urRs5aI?si=ItTKmrFpgF6VRmvT",
      repo: "https://github.com/abdulawalarif/user_app"
    }
  },


  {
    //2
    name: "Online Store Admin Panel",
    heading: "Manage your products, orders, and users in one place.",
    details: "An intuitive admin panel designed for store owners to efficiently manage inventory, process orders, handle customers, and update product listings with multiple images. Includes easy media management, order tracking, user control, customizable themes, and more to streamline daily operations.",
    thumb: adminApp,
    tech: "Flutter/Dart/Firebase",
    links: {
      live: "https://youtu.be/A1gQL1-QRtc?si=2ezWqBhoWQPxK0Wq",
      repo: "https://github.com/abdulawalarif/shop_owner_app"
    }
  },



  {
    //3
    name: "Facebook feed",
    heading: "I had to integrate a Facebook news feed for a mobile application, so I open-sourced this UI module to help other developers.",
    details: "This project integrate Facebook Feed Graph API into mobile apps. It focuses solely on the UI implementation there is no backend integration included. Features include: user authentication (login, registration, password recovery), creating posts with various backgrounds with images, loading posts with a mock data, and interacting with posts via comments and emoji reactions.",
    thumb: facebookFeed,
    tech: "Flutter and Dart",

    links: {
      live: "https://youtube.com/shorts/tf58-QJZmEo?si=3he-8EHu6Ic_3RUO",
      repo: "https://github.com/abdulawalarif/facebook_feed"
    }
  },
  {
    //4
    name: "Health Data app",
    heading: "An app for the World Health Organization(WHO) purpose was surveying health data in Somalia.",
    details: "This Mobile app was developed for the World Health Organization (WHO) to support health data surveys in Somalia. It allows health workers to collect user data both online and offline. All network requests are cached locally, and data is sent to a REST API whenever the network becomes available. The app is user-friendly, supports both English and Somali languages, and is designed to work reliably in no-internet environments.",
    thumb: healthDataApp,
    tech: "Flutter/Dart/REST API/SQLite",
    links: {
      live: "https://play.google.com/store/apps/details?id=com.health_data_app&pli=1",
      repo: "https://github.com/abdulawalarif/health_data_app"
    }
  },


  //

  {
    //5
    name: "Koko Live",
    heading: "Live Streaming App.",
    details: "Koko Live is a live streaming platform built using ZEGOCLOUD for real-time video broadcasting, Firebase Authentication for secure user management, and integrated real-time chat. Designed with both performance and user experience in mind.",
    thumb: kokoLive,
    tech: "Flutter/Dart/Firebse/REST API",
    links: {
      live: "x",
      repo: "x"
    }
  },





  {
    //6
    name: "Task Management App",
    heading: "A Mobile app UI for managing tasks.",
    details: "This task management app focuses on a clean, minimal, and intuitive UI for tracking tasks. Currently, it includes UI components only, allowing users to navigate through various screens and experience the design. Key features include: 1. Task Overview Dashboard:  View tasks organized into categories such as To-Do, In Progress, and Done. 2. Active Projects Section:  Track progress across multiple projects with visual indicators. 3. Task Creation Flow: Add new tasks with details like title, date, start/end time, description, and category. 4. Task Scheduling: Display a daily task timeline with ease.",
    thumb: taskManagementApp,
    tech: "flutter and Dart",
    links: {
      live: "https://youtube.com/shorts/SG7sEMYGfT4?si=05e7zHHtL_7LD60x",
      repo: "https://github.com/abdulawalarif/task_management_app"
    }
  },







  {
    //7 order status

    name: "Real-Time Order Tracking",
    heading: "Keep customers informed every step of the way.",
    details: "An interactive UI that allows users to track their orders in real time with smooth status updates and delivery confirmations. Designed for easy integration and complete customization to match any e-commerce app's branding and theme.",
    thumb: orderStatus,
    tech: "Flutter and Dart",
    links: {
      live: "https://youtube.com/shorts/Pl9P6SIJJb8?si=b9IWzmNb0BTNb3a6",
      repo: "https://github.com/abdulawalarif/order_status"
    }
  },


  //

  {
    //8 form management
    name: "User Registration Form Template",
    heading: "Form management with Regular expression for email validations.",
    details: "A ready-to-use registration form designed to simplify user onboarding. It includes responsive layouts, real-time validation feedback, and efficient handling of multiple form fields, making it ideal for apps that require smooth and reliable user data collection.",
    thumb: registrationForm,
    tech: "Flutter/Dart",
    links: {
      live: "https://youtube.com/shorts/phqY0fphzWc?si=f3rqDJoJUHx3HsQI",
      repo: "https://gist.github.com/abdulawalarif/ccaf9999f143c0bebaec5ef09d3b9829"
    }
  },






  {
    //9 Multiple image viewer with flutter
    name: "Multi Image Viewer",
    heading: "Interactive Image Viewer",
    details: "A sleek and responsive multiple image viewer, designed specifically for e-commerce product detail pages. This component enables users to smoothly browse through product images, providing a seamless and user-friendly experience.",
    thumb: multiImageView,
    tech: "flutter/dart",
    links: {
      live: "https://youtube.com/shorts/Otx1aQLS-CA?si=Db9jI2OHLC5aJKPv",
      repo: "https://gist.github.com/abdulawalarif/bb6261e12e19085906ddc35c3b6d942f"
    }
  },
  //


  {
    //10 Multiple image viewer with flutter

    name: "Multi-Step Form UI Kit",
    heading: "Create seamless multi-step forms with a clean, guided experience.",
    details: "A ready-to-use UI kit designed to enhance form submission flows with a structured, step-by-step process. It features progress tracker, visual tick marks for completed steps, and a final summary screen, helping users navigate complex forms easily. Ideal for any app requiring organized and intuitive form interactions across platforms.",
    thumb: stepperFormUI,
    tech: "Flutter/Dart",
    links: {
      live: "https://youtube.com/shorts/ww0UUooAq9E?si=p3V1CYjWetFA2GKC",
      repo: "https://github.com/abdulawalarif/stepper_for_ecommerce"
    }
  },






  {
    name: "Abdul Awal's Portfolio",
    heading: "Showcasing my skills, projects, and journey as a developer.",
    details: "A personal portfolio website highlighting my experience, projects, and skills as a developer. Explore my work in Flutter, backend development, and more. Stay updated on my journey and find links to my GitHub repositories and social profiles.",
    thumb: thiApp,
    tech: "JS/React/HTML/CSS",
    links: {
      live: "https://abdulawalarif.github.io/",
      repo: "https://github.com/abdulawalarif/abdulawalarif.github.io"
    }
  },


  {
    //12
    name: "Personal Expense Tracker REST API",
    heading: "Effortlessly track and manage expenses",
    details: "This REST API enables users to securely authenticate, manage their profiles, and track expenses efficiently. Features include robust user authentication, profile management, expense tracking, and secure data handling.",
    thumb: expenseManagementRESTAPI,
    tech: "JS/Node/Express/Firebase",
    links: {
      live: "https://github.com/abdulawalarif/Expense-namagement-with-node-express-firebase",
      repo: "https://github.com/abdulawalarif/Expense-namagement-with-node-express-firebase"
    }
  },


  {
    //13
    name: "Product Management Microservice",
    heading: "Microservice REST API for managing product data.",
    details: "This REST API provides CRUD operations for product management. It features built-in user authentication via Django admin, ensuring secure create, update, and delete operations. GET requests are publicly accessible without authentication.",
    thumb: djangoRESTFramework,
    tech: "Python/Django REST framework/MySQL",
    links: {
      live: "https://awalarifdr.pythonanywhere.com/",
      repo: "https://github.com/abdulawalarif/ecommerce_backend_DRF"
    }
  }
];

export const getProjectBySlug = (slug) =>
  projectsData.find((project) => getProjectSlug(project.name) === slug);

export const writingsData = [

  {
    title: "Building a Local SQLite CRUD App in Flutter",
    publishedOn: "Medium",
    link: "https://medium.com/@abdulAwalArif/building-a-local-sqlite-crud-app-in-flutter-6b210139a14a"
  },


  {
    title: "Create a Native Splash Screen in Flutter Using flutter_native_splash",
    publishedOn: "Medium",
    link: "https://medium.com/@abdulAwalArif/create-splash-screen-in-flutter-using-flutter-native-splash-7ce927d55980"
  },

  {
    title: "Building hot-reload functionality in a Golang project with docker",
    publishedOn: "Medium",
    link: "https://medium.com/@abdulAwalArif/building-hot-reload-functionality-in-a-golang-project-with-docker-a6f1d95d9bbe"
  },


  {
    title: "Managing flutter apps state with a combination of ChangeNotifiers and ValueNotifiers",
    publishedOn: "Medium",
    link: "https://medium.com/@abdulAwalArif/managing-flutter-apps-state-with-a-combination-of-changenotifiers-and-valuenotifiers-65fb1e8bc65e"
  },


  {
    title: "Sign-In with google with flutter and firebase",
    publishedOn: "Medium",
    link: "https://medium.com/@abdulAwalArif/sign-in-with-google-with-flutter-and-firebase-97a18f588233"
  },
  {
    title: "Flutter and Firebase: Deleting Storage Images When Updating",
    publishedOn: "Medium",
    link: "https://medium.com/@abdulAwalArif/efficient-image-management-in-flutter-and-firebase-deleting-storage-images-when-updating-aa53e1e104b9"
  },
  {
    title: "Fetching a list of data from Firebase Cloud Firestore with Flutter",
    publishedOn: "Medium",
    link: "https://medium.com/@abdulAwalArif/fetching-a-list-of-data-from-firebase-cloud-firestore-with-flutter-6017f6bec815"
  },
  {
    title: "How to Truncate Text in Flutter for Clean UI Design",
    publishedOn: "Medium",
    link: "https://medium.com/@abdulAwalArif/how-to-truncate-text-in-flutter-for-clean-ui-design-e643c85ad2df"
  },
  {
    title: "Understanding Logarithms",
    publishedOn: "Medium",
    link: "https://medium.com/@abdulAwalArif/understanding-logarithms-5547af888333"
  },
  {
    title: "Order status tracker with Flutter",
    publishedOn: "Medium",
    link: "https://medium.com/@abdulAwalArif/order-status-tracker-with-flutter-9e648dd0a037"
  },
  {
    title: "Dart Logging with Extensions: Enhancing Performance and Readability",
    publishedOn: "Medium",
    link: "https://medium.com/@abdulAwalArif/dart-logging-with-extensions-enhancing-performance-and-readability-f578f70695a4"
  },


  {
    title: "Pushing a large model into Firebase with flutter",
    publishedOn: "Medium",
    link: "https://medium.com/@abdulAwalArif/pushing-a-large-model-into-firebase-with-flutter-3fa263ed9ac9"
  },

  {
    title: "Creating a model with Json Serializable & Build Runner In Flutter",
    publishedOn: "Medium",
    link: "https://medium.com/@abdulAwalArif/creating-a-model-with-json-serializable-build-runner-in-flutter-243b76b1b737"
  },

];

